<template>
  <div
    class="buildingInforPage mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftBox">
      <TreeMenu @getActiveItem="getActiveItem" />
    </div>
    <div class="rightBox">
      <div class="topBox ashComWrap">
        <div class="infoWrap">
          <h5>{{ treeActive.name }}</h5>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="v in tabList"
              :key="v.name"
              :label="v.name"
              :name="v.value"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="codeWrap">
          <div class="qrcodeBox" ref="qrcode"></div>
          <p>区域ID:{{ treeActive.id }}</p>
        </div>
      </div>
      <div class="bottomBox">
        <RegionalEquipment
          v-if="activeName == '区域设备'"
          :treeActive="treeActive"
        />
        <UsageDetails v-if="activeName == '使用详情'" />
        <Instructions
          v-if="activeName == '使用说明'"
          :treeActive="treeActive"
        />
        <div
          class="recordBox ashComWrap"
          v-if="
            activeName == '巡检' || activeName == '保洁' || activeName == '工单'
          "
        >
          <TablePublicCom
            :activeName="activeName"
            :system="'建筑系统'"
            :assetId="treeActive.id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeMenu from "@/components/zixitong/TreeMenu";
import TablePublicCom from "@/components/DevOps/TablePublicCom.vue";
import Instructions from "@/components/zixitong/buildingInfor/Instructions.vue";
import UsageDetails from "@/components/zixitong/buildingInfor/UsageDetails.vue";
import RegionalEquipment from "@/components/zixitong/buildingInfor/RegionalEquipment.vue";
import QRCode from "qrcodejs2";
export default {
  components: {
    TreeMenu,
    TablePublicCom,
    Instructions,
    UsageDetails,
    RegionalEquipment,
  },
  data() {
    return {
      qrcode: null,
      activeName: "区域设备",
      tabList: [
        { name: "区域设备", value: "区域设备" },
        // { name: "使用详情", value: "使用详情" },
        { name: "使用说明", value: "使用说明" },
        { name: "巡检记录", value: "巡检" },
        // { name: "保洁记录", value: "保洁" },
        { name: "工单记录", value: "工单" },
      ],
      treeActive: {},
      treeData: {},
      num: 0,
    };
  },
  methods: {
    getActiveItem(val) {
      this.treeData = val;
      this.num += 1;
      this.treeActive = Object.assign({}, val, { countNum: this.num });
      this.creatQrCode();
    },

    creatQrCode() {
      let text = `${window.jujiParams.baseURL}?assetId=${this.treeActive.id}`;
      this.$refs.qrcode.innerHTML = "";
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: text,
        width: 90,
        height: 90,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
    },

    handleClick(tab, event) {},
  },
};
</script>

<style lang="scss" scoped>
.buildingInforPage {
  @include setFlexBetween;
  .leftBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWH;
    .topBox {
      height: 20%;
      @include setFlexBetween;
      .infoWrap {
        width: 70%;
        height: 90%;
        margin-left: 20px;
        h5 {
          height: 70%;
          font-size: 24px;
          @include setFlexStart;
        }
        ::v-deep .el-tabs__nav-wrap::after {
          background-color: transparent;
        }
      }
      .codeWrap {
        margin-right: 20px;
        @include setFlexColumn;
        align-items: center;

        .qrcodeBox {
          width: 90px;
          height: 90px;
        }
        p {
          text-align: center;
          margin-top: 10px;
        }
      }
    }
    .bottomBox {
      width: 100%;
      height: calc(80% - 12px);
      margin-top: 12px;
      // background: sandybrown;
    }
  }
}
</style>
